import CheckmarkLargeIcon from '@assets/icons/checkmark-large.svg';
import React, { useState } from 'react';
import { Button, SIZES } from '@/components/button';
import { createStyles } from '@/contexts/theme-context';
import { PixelRatio, View } from 'react-native';
import { TextInput } from '@/components/text-input';

const fontScale = PixelRatio.getFontScale();

export const INPUT_HEIGHT = SIZES.small * fontScale;

interface AddItemInputProps {
  initialValue?: undefined;
  onBlur?: undefined;
  placeholder: string;
}

interface EditItemInputProps {
  initialValue: string;
  onBlur: () => void;
  placeholder?: undefined;
}

type Props = (AddItemInputProps | EditItemInputProps) & {
  loading: boolean;
  onSubmit: (value: string) => Promise<void>;
};

export const SmartOrderIndividualInput: React.FC<Props> = ({
  initialValue = '',
  loading,
  placeholder,
  onBlur,
  onSubmit,
}) => {
  const [styles] = useStyles();
  const [inputValue, setInputValue] = useState(initialValue);
  const trimmedValue = inputValue.trim();

  const hideButton = placeholder && !inputValue && !loading;

  return (
    <View style={styles.base}>
      <TextInput
        autoFocus={!placeholder}
        containerStyle={styles.inputContainer}
        onChangeText={setInputValue}
        placeholder={placeholder}
        style={styles.input}
        value={inputValue}
      />
      {hideButton ? null : (
        <Button
          disabled={!trimmedValue}
          Icon={CheckmarkLargeIcon}
          loading={loading}
          onPress={async () => {
            if (trimmedValue === initialValue) {
              onBlur?.();
            } else {
              await onSubmit(trimmedValue);
              setInputValue(initialValue);
            }
          }}
          size="small"
          style={styles.button}
          testID="smart-order-individual-submit-button"
          trackingData={{
            name: 'smart_order.individual_input_submit',
            properties: {
              value: trimmedValue,
            },
          }}
        />
      )}
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  base: {
    flex: 1,
    flexDirection: 'row',
    gap: 8,
    maxWidth: 768,
  },
  button: {
    height: INPUT_HEIGHT,
    minWidth: INPUT_HEIGHT,
    paddingHorizontal: 0,
  },
  input: {
    fontSize: theme.fontSizes.small,
  },
  inputContainer: {
    borderColor: theme.colors.stroke,
    flex: 1,
    height: INPUT_HEIGHT,
  },
}));
